import { z } from 'zod';
// Lookup (controlled-vocabulary) API DTOs. DB-backed allowed values for GTM
// categorical attributes, super-admin managed (no deploy to add/edit). See
// packages/db/src/schema/lookups.ts.
// Known lookup categories (registry of what's manageable). Adding a brand-new
// category is just adding an entry here + seeding rows; the backing column then
// validates against it. `usage` documents which column it controls.
export const LOOKUP_CATEGORIES = [
    {
        key: 'persona_department',
        label: 'Persona: Department',
        usage: 'personas.department',
    },
    {
        key: 'persona_seniority',
        label: 'Persona: Seniority',
        usage: 'personas.seniority',
    },
    {
        key: 'persona_buyer_role',
        label: 'Persona: Buyer Role',
        usage: 'personas.buyer_role',
    },
];
export const lookupValueSchema = z.object({
    id: z.string(),
    category: z.string(),
    value: z.string(),
    label: z.string(),
    sort_order: z.number(),
    source: z.string(), // 'seed' | 'custom'
    // How many rows currently use this value (drives delete-protection in the UI).
    usage_count: z.number(),
});
export const lookupValuesListResponseSchema = z.object({
    values: z.array(lookupValueSchema),
});
export const createLookupValueRequestSchema = z.object({
    category: z.string().min(1).max(64),
    value: z.string().min(1).max(128),
    label: z.string().min(1).max(160),
    sort_order: z.number().int().optional(),
});
// Only label/sort are editable — changing `value` would orphan existing rows
// that store the old value, so it's immutable (add a new one + migrate instead).
export const updateLookupValueRequestSchema = z.object({
    label: z.string().min(1).max(160).optional(),
    sort_order: z.number().int().optional(),
});
//# sourceMappingURL=lookups.js.map